module.exports = __webpack_public_path__ + "img/5.4f9cd751.jpg";